<template>
  <div>
    <b-card v-for="issue in page_issues" no-body :key="issue.id" class="my-2">
      <b-card-body>
        <component :is="style.icon" :variant="style.variant" class="mr-2" />
        <template v-if="issue.id == 'server'">
          <strong
            >{{
              page.status_code == 404 ? '404 Not Found' : 'Server Error'
            }}:</strong
          > The page responded with a
          <b-badge variant="danger">{{ page.status_code }}</b-badge>
          error. 
          <template v-if="page.status_code == 404">
            Restore the page, or redirect it to a valid URL.
          </template>
        </template>

        <template v-else-if="issue.id == 'redirect'">
          <strong>Redirected:</strong>
          The page responded with a
          <b-badge variant="warning">{{ page.status_code }}</b-badge>
          redirect
          <template v-if="issue.value.url">
            to
            <a :href="issue.value.url" target="_blank">{{
              issue.value.url
            }}</a>
          </template>
          <template v-if="issue.score">
            which&nbsp;responded with a
            <b-badge variant="danger">{{ issue.value.status_code }}</b-badge>
            error
          </template>
        </template>

        <template v-else-if="issue.id == 'canonical'">
          <strong>Canonicalized:</strong>
          The page is canonicalized to
          <a :href="issue.value.url" target="_blank">{{ issue.value.url }}</a>
          <template v-if="issue.score">
            which&nbsp;responded with a
            <b-badge
              :variant="issue.value.status_code < 400 ? 'warning' : 'danger'"
              >{{ issue.value.status_code }}</b-badge
            >
          </template>
        </template>

        <template v-else-if="issue.id == 'response_time'">
          <strong>Noticeably Slow Page Load:</strong>
          The page has a
          <strong>{{ issue.value.response_time | formatNumber }} ms</strong>
          average response time this week. Improve your server's response time to
          increase traffic.
          <a href="/documentation/crawl-issues/" class="text-small"
            >Help <b-icon-box-arrow-up-right
          /></a>
        </template>

        <template v-else-if="issue.id == 'missing_viewport'">
          <strong>Poor Mobile Experience:</strong>
          The page is missing a <code>viewport</code> meta tag, which is
          important to deliver a good mobile experience. Fixing mobile issues
          can increase your organic traffic.
          <a href="/documentation/crawl-issues/" class="text-small"
            >Help <b-icon-box-arrow-up-right
          /></a>
        </template>

        <template v-else-if="issue.id == 'placeholder_template'">
          <strong>Unmodified Default Template:</strong>
          It looks like this page was created from a template and not customized for your site. Consider deleting it (and add a redirect to a valid page), or updating it's content.
        </template>

        <template v-else-if="issue.id == 'placeholder_url'">
          <strong>Update the placeholder URL of this page:</strong>
          The URL of this page looks like it was not updated from the template's default. We recommend customizing it, and consider adding a redirect to the new URL to avoid 404 errors.
        </template>

        <template v-else-if="issue.id == 'placeholder_text'">
          <strong>Page Contains Placeholder Text:</strong>
          There's content on the page that looks to be from the default template. Consider deleting it, or updating it:
        </template>

        <template v-else-if="issue.id == 'placeholder_footer_text'">
          <strong>Site Footer Contains Placeholder Text:</strong>
          There's content in the site footer that looks to be from the default template. Consider deleting it, or updating it:
        </template>
        <b-link
          v-if="!isExpanded(issue) && issue.data && issue.data.length > 1"
          v-b-toggle="`accordion-${issue.id}`"
          class="ml-1 text-nowrap"
          >Details
          <b-icon-chevron-down class="when-closed" /><b-icon-chevron-up
            class="when-open"
        /></b-link>
      </b-card-body>
      <b-collapse
        v-if="issue.data && issue.data.length"
        :visible="isExpanded(issue) || issue.data.length == 1"
        :id="`accordion-${issue.id}`"
        :accordion="isExpanded(issue) ? null : 'issues-accordion'"
        role="tabpanel"
      >
        <b-list-group flush class="text-small text-muted">
          <b-list-group-item v-for="item of issue.data" :key="item">{{item}}</b-list-group-item>
        </b-list-group>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'PageIssues',
  props: ['page', 'page_issues', 'expanded'],
  components: {},
  computed: {
    worstIssue() {
      return _.maxBy(this.page_issues, 'score') || {}
    },
    style() {
      switch (this.worstIssue.score) {
        case 100:
          return {
            icon: 'b-icon-exclamation-triangle-fill',
            variant: 'danger'
          }
        case 0:
          return {
            icon: 'b-icon-info-circle',
            variant: 'primary'
          }
        default:
          return {
            icon: 'b-icon-exclamation-triangle-fill',
            variant: 'warning'
          }
      }
    }
  },
  methods: {
    isExpanded(issue) {
      return issue.id == this.expanded
    }
  }
}
</script>